<main class="bg-white dark:bg-slate-900 min-h-screen flex flex-col">
    <div class="grid grid-cols-1 lg:grid-cols-2 min-h-screen relative overflow-hidden">

        <!-- Left content -->
        <div
            class="relative flex flex-col justify-center px-6 lg:pl-16 py-12 lg:py-20 space-y-6 text-center lg:text-left bg-white z-10">
            <h1 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D4BA6] font-arimo leading-tight">
                <span class="block">Empowering Technologies.</span>
                <span class="block text-[#E17A17]">Enabling Global Growth.</span>
            </h1>


            <p class="text-gray-600 text-base sm:text-lg font-poppins leading-relaxed max-w-xl mx-auto lg:mx-0">
                Sriee Holdings is a premier global distribution partner, connecting groundbreaking emerging
                technologies with markets worldwide. We empower innovations to thrive by forging strategic
                partnerships across the globe.
            </p>

            <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a href="#sectors" [ngClass]="getLinkClasses('sectors')"
                    class="px-6 py-3 bg-[#1D4BA6] text-white font-medium rounded-lg shadow-md hover:bg-[#E17A17] hover:text-[#1D4BA6] transition">
                    Discover Our Sectors
                </a>
                <!-- <a href="#partnership" 
                    class="px-6 py-3 border border-[#1D4BA6] text-[#1D4BA6] font-medium rounded-lg hover:bg-[#1D4BA6] hover:text-white transition">
                    Explore a Partnership
                </a> -->
            </div>
        </div>

        <!-- Right column with wave background -->
        <div class="relative hidden lg:flex items-center justify-center bg-white dark:bg-white">
            <div class="absolute inset-0">
                <img src="/blue-vertical-wave.svg" alt="Blue wave background"
                class="absolute inset-10 w-full h-full object-fill transform -rotate-90" />
            </div>

            <img src="/globe-ai.png"
                alt="Futuristic technology illustration"
                class="logo-animate opacity-0 scale-75 relative z-10 w-full max-w-lg lg:max-w-xl object-contain transition-all duration-700"
                loading="lazy"/>
        </div>
    </div>

    <!-- About us section -->
    <section id="about" class="relative bg-cover bg-center bg-no-repeat"
        style="background-image: url('/2151003789.jpg');">
        <!-- Overlay -->
        <div class="absolute inset-0 bg-[#1D4BA6] bg-opacity-30"></div>

        <div class="relative max-w-7xl mx-auto px-6 lg:px-12 py-48 text-center lg:text-left text-white">
            <div class="animate-fadeInUp">
                <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
                    About Us
                </h2>
                <p class="text-lg sm:text-xl leading-relaxed max-w-3xl mx-auto lg:mx-0">
                    “Through strategic partnerships with governments, corporations, and industry leaders,
                    we accelerate adoption of frontier technologies and transform innovation into real impact.
                    <br /><br />
                    We don’t just bring technology to market — we ensure it thrives.”
                </p>
            </div>
        </div>
    </section>

    <!-- Emerging Sectors Section -->
    <section id="sectors" class="relative bg-gray-50 dark:bg-slate-800 py-20">
        <div class="max-w-7xl mx-auto px-6 lg:px-12">
            <div class="text-center mb-12">
                <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D4BA6] dark:text-white">
                    Emerging Sectors
                </h2>
                <p class="text-gray-600 dark:text-gray-300 mt-4 max-w-2xl mx-auto">
                    Exploring the frontier industries driving the next wave of innovation and transformation.
                </p>
            </div>

            <!-- Cards Grid -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-6 flex flex-col items-start">
                    <div class="text-4xl mb-4 text-[#E17A17]">🛰️</div>
                    <h3 class="text-xl font-semibold mb-2 text-[#1D4BA6] dark:text-white">
                        SpaceTech & Satellite Constellations
                    </h3>
                    <p class="text-gray-600 dark:text-gray-400 flex-1">
                        Satellite launches, constellations, and ground stations for global connectivity.
                    </p>
                    <!-- <button class="mt-4 text-[#E17A17] font-medium hover:underline">
                        Learn More →
                    </button> -->
                </div>

                <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-6 flex flex-col items-start">
                    <div class="text-4xl mb-4 text-[#E17A17]">⚡</div>
                    <h3 class="text-xl font-semibold mb-2 text-[#1D4BA6] dark:text-white">
                        Next-Gen Energy & Batteries
                    </h3>
                    <p class="text-gray-600 dark:text-gray-400 flex-1">
                        Advanced batteries, EV infrastructure, and hydrogen power fueling the clean energy transition.
                    </p>
                    <!-- <button class="mt-4 text-[#E17A17] font-medium hover:underline">
                        Learn More →
                    </button> -->
                </div>

                <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-6 flex flex-col items-start">
                    <div class="text-4xl mb-4 text-[#E17A17]">🌞</div>
                    <h3 class="text-xl font-semibold mb-2 text-[#1D4BA6] dark:text-white">
                        Solar & Clean Energy (CleanTech)
                    </h3>
                    <p class="text-gray-600 dark:text-gray-400 flex-1">
                        High-efficiency solar, waste-to-energy, and advanced recycling systems.
                    </p>
                    <!-- <button class="mt-4 text-[#E17A17] font-medium hover:underline">
                        Learn More →
                    </button> -->
                </div>

                <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-6 flex flex-col items-start">
                    <div class="text-4xl mb-4 text-[#E17A17]">🌊⚡</div>
                    <h3 class="text-xl font-semibold mb-2 text-[#1D4BA6] dark:text-white">
                        Osmotic Power Systems (Blue Energy)
                    </h3>
                    <p class="text-gray-600 dark:text-gray-400 flex-1">
                        Turning river–sea flows into 24/7 clean electricity., expandable with “Learn More.”
                    </p>
                    <!-- <button class="mt-4 text-[#E17A17] font-medium hover:underline">
                        Learn More →
                    </button> -->
                </div>

                <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-6 flex flex-col items-start">
                    <div class="text-4xl mb-4 text-[#E17A17]">🏭</div>
                    <h3 class="text-xl font-semibold mb-2 text-[#1D4BA6] dark:text-white">
                        Digital Twin & Industry 4.0
                    </h3>
                    <p class="text-gray-600 dark:text-gray-400 flex-1">
                        IoT-driven models for factories, cities, and logistics — enabling smarter operations.
                    </p>
                    <!-- <button class="mt-4 text-[#E17A17] font-medium hover:underline">
                        Learn More →
                    </button> -->
                </div>

                <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-6 flex flex-col items-start">
                    <div class="text-4xl mb-4 text-[#E17A17]">🧬</div>
                    <h3 class="text-xl font-semibold mb-2 text-[#1D4BA6] dark:text-white">
                        Bio-integrated Electronics & MedTech
                    </h3>
                    <p class="text-gray-600 dark:text-gray-400 flex-1">
                        Wearables and implantable diagnostics transforming healthcare and wellness.
                    </p>
                    <!-- <button class="mt-4 text-[#E17A17] font-medium hover:underline">
                        Learn More →
                    </button> -->
                </div>

                <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-6 flex flex-col items-start">
                    <div class="text-4xl mb-4 text-[#E17A17]">💻</div>
                    <h3 class="text-xl font-semibold mb-2 text-[#1D4BA6] dark:text-white">
                        Quantum & Next-Gen Computing
                    </h3>
                    <p class="text-gray-600 dark:text-gray-400 flex-1">
                        Quantum systems and neuromorphic chips shaping the future of AI, defense, and finance.
                    </p>
                    <!-- <button class="mt-4 text-[#E17A17] font-medium hover:underline">
                        Learn More →
                    </button> -->
                </div>

                <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-6 flex flex-col items-start">
                    <div class="text-4xl mb-4 text-[#E17A17]">🚗</div>
                    <h3 class="text-xl font-semibold mb-2 text-[#1D4BA6] dark:text-white">
                        Advanced Mobility
                    </h3>
                    <p class="text-gray-600 dark:text-gray-400 flex-1">
                        The future of transportation is autonomous, electric, and on-demand.
                    </p>
                    <!-- <button class="mt-4 text-[#E17A17] font-medium hover:underline">
                        Learn More →
                    </button> -->
                </div>

                <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-6 flex flex-col items-start">
                    <div class="text-4xl mb-4 text-[#E17A17]">🛡️</div>
                    <h3 class="text-xl font-semibold mb-2 text-[#1D4BA6] dark:text-white">
                        Dual-Use Defense Technologies
                    </h3>
                    <p class="text-gray-600 dark:text-gray-400 flex-1">
                        AI surveillance, UAVs, and cybersecurity solutions for defense and enterprise.
                    </p>
                    <!-- <button class="mt-4 text-[#E17A17] font-medium hover:underline">
                        Learn More →
                    </button> -->
                </div>
            </div>
        </div>
    </section>

    <!-- What We Deliver Section -->
    <section id="deliver" class="relative bg-[#1D4BA6] bg-opacity-90 py-20 text-white">
        <div class="absolute inset-0 bg-[#1D4BA6] opacity-60 bg-center bg-contain bg-no-repeat" style="background-image: url('/world-map.png');">
        </div>

        <div class="relative max-w-7xl mx-auto px-6 lg:px-12">
            <div class="text-center mb-12">
                <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold">
                    What We Deliver?<br />
                    <span class="text-[#E17A17]">(Core Services)</span>
                </h2>
                <p class="mt-4 text-lg sm:text-xl max-w-3xl mx-auto text-gray-200 italic">
                    From Innovation to Worldwide Adoption — Transforming your vision into global impact
                </p>
            </div>

            <!-- Cards Grid -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                <div class="bg-[#E17A17] border-2 border-white text-white rounded-2xl shadow-lg p-6 flex flex-col">
                    <div class="text-4xl mb-4">🌍</div>
                    <h3 class="text-xl font-semibold mb-2">Global Distribution & Market Expansion</h3>
                    <p class="flex-1">
                        Leverage our extensive global network and logistics expertise to bring your product to
                        new customers in multiple countries, expanding your brand's international footprint.
                    </p>
                </div>

                <div class="bg-[#1D4BA6] border-2 border-white rounded-2xl shadow-lg p-6 flex flex-col">
                    <div class="text-4xl mb-4 text-[#E17A17]">🤝</div>
                    <h3 class="text-xl font-semibold mb-2 text-white">Strategic Connections</h3>
                    <p class="text-gray-300 flex-1">
                        We open doors to key opportunities by connecting your technology with trusted
                        decision-makers in governments, corporations, and industry-leading enterprises.
                    </p>
                </div>

                <div class="bg-[#E17A17] border-2 border-white text-white rounded-2xl shadow-lg p-6 flex flex-col">
                    <div class="text-4xl mb-4">🎯</div>
                    <h3 class="text-xl font-semibold mb-2">Customer Acquisition</h3>
                    <p class="flex-1">
                        Our on-the-ground market expertise and targeted outreach strategies help you identify,
                        engage, and acquire customers across international markets, driving sales and revenue.
                    </p>
                </div>

                <div class="bg-[#1D4BA6] border-2 border-white rounded-2xl shadow-lg p-6 flex flex-col">
                    <div class="text-4xl mb-4 text-[#E17A17]">📈</div>
                    <h3 class="text-xl font-semibold mb-2 text-white">Scalable Growth</h3>
                    <p class="text-gray-300 flex-1">
                        We provide a clear pathway for your technology's growth, ensuring it can scale effectively
                        and sustainably to meet the demands of a global market.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <!-- Why Sriee Holdings Section with Parallax -->
    <section id="why" class="relative bg-fixed bg-center bg-cover py-32 text-white"
        style="background-image: url('/69450352_23_689.jpg');">

        <!-- Overlay for readability -->
        <div class="absolute inset-0 bg-[#1D4BA6] bg-opacity-10"></div>

        <div class="relative max-w-4xl mx-auto px-6 text-center">
            <!-- Logo with Scroll + Flip Animation -->
            <div
                class="flex justify-center mb-10 transform scale-75 transition-all duration-1000 ease-out logo-animate">

                <div class="flip-container w-32 h-32 md:w-48 md:h-48">
                    <div class="flip-inner">
                        <!-- Front -->
                        <div class="flip-front">
                            <img src="/sriee-thumbnail.png" alt="Sriee Holdings Logo"
                                class="w-full h-full object-contain " />
                        </div>
                        <!-- Back (optional: can use same image/text) -->
                        <div class="flip-back">
                            <img src="/sriee-thumbnail.png" alt="Sriee Holdings Logo"
                                class="w-full h-full object-contain " />
                        </div>
                    </div>
                </div>

            </div>

            <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 text-[#1D4BA6]">
                Why Sriee Holdings?
            </h2>
            <p class="text-lg sm:text-xl leading-relaxed text-gray-600">
                We are more than a distribution partner; we are a strategic extension of your team.
                With a proven global network and deep industry expertise, we transform innovation into impact,
                ensuring that emerging technologies don’t just reach the market, but thrive worldwide.
            </p>
        </div>
    </section>



    <!-- Partnerships & Network Section -->
    <!-- commented out as per new requirement -->
    <!-- <section id="partnership"
        class="relative bg-gradient-to-b from-gray-50 to-white dark:from-slate-800 dark:to-slate-900 py-20">
        <div class="max-w-7xl mx-auto px-6 lg:px-12 text-center">

            <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D4BA6] dark:text-white">
                Partnerships & Network
            </h2>
            <div class="w-24 h-1 bg-[#E17A17] mx-auto mt-3 rounded"></div>
            <p class="mt-4 text-lg sm:text-xl text-gray-600 dark:text-gray-300">
                Trusted by Leading Innovators
            </p>

            <div
                class="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-10 items-center justify-center">
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner1.svg" alt="Partner 1"
                        class="h-20 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner2.svg" alt="Partner 2"
                        class="h-24 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner3.svg" alt="Partner 3"
                        class="h-20 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner4.svg" alt="Partner 4"
                        class="h-24 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner5.png" alt="Partner 5"
                        class="h-24 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner6.png" alt="Partner 6"
                        class="h-24 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
            </div>
        </div>
    </section> -->


    <!-- Global Presence Section -->
    <section id="presence" class="relative bg-gray-50 dark:bg-slate-900 py-20">
        <div class="max-w-7xl mx-auto px-6 text-center">
            <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#E17A17] dark:text-white mb-4">
                Global Presence
            </h2>
            <p class="text-lg sm:text-xl text-gray-600 dark:text-gray-300 mb-5">
                Empowering Technology. Enabling Global Growth.
            </p>

            <!-- Map Container -->
            <div class="relative w-full max-w-6xl mx-auto">
                <img src="/world-map-sriee.png" alt="World Map" class="w-full" />

                <!-- Hotspot Example: North America -->
                <div class="absolute top-[30%] left-[20%] flex flex-col items-left lg:flex-row lg:items-center">
                    <!-- Dot -->
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>

                    <!-- Label -->
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        North America
                    </div>
                </div>

                <!-- Hotspot: Europe -->
                <div class="absolute top-[28%] left-[50%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Europe
                    </div>
                </div>

                <!-- Hotspot: Asia -->
                <div class="absolute top-[35%] left-[70%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Asia
                    </div>
                </div>

                <!-- Hotspot: Middle East -->
                <div class="absolute top-[42%] left-[58%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Middle East
                    </div>
                </div>

                <!-- Hotspot: Africa -->
                <div class="absolute top-[55%] left-[50%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Africa
                    </div>
                </div>

                <!-- Hotspot: Australia -->
                <div class="absolute top-[75%] left-[85%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Australia
                    </div>
                </div>
            </div>

        </div>
    </section>


    <!-- Call-to-Action Section -->
    <section id="contact" class="relative bg-[#1D4BA6] text-white py-20">
        <div class="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-12">

            <!-- Left Content -->
            <div class="flex flex-col justify-center">
                <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
                    Let’s Transform Innovation into Global Impact.
                </h2>
                <p class="text-lg sm:text-xl text-gray-200 mb-8">
                    Ready to scale your innovation to global markets? Partner with us today.
                </p>

                <!-- Contact Details -->
                <div class="space-y-4 text-gray-200">
                    <p><strong>Office:</strong> Registered Office (Singapore HQ): 1 Raffles Place, <br /> #34-04 One
                        Raffles Place, Singapore 048616, Singapore</p>
                    <p><strong>Phone:</strong> +65 9113 0004 & 05 (Singapore line)</p>
                    <p><strong>Email:</strong> info&#64;srieeholdings.sg</p>
                </div>

                <!-- Buttons -->
                <div class="mt-8 flex flex-wrap gap-4">
                    <!-- Contact button -->
                    <button type="button" (click)="toggleForm('contact')"
                        [ngClass]="!showWorkWithUs ? 'bg-[#E17A17] text-[#1D4BA6] shadow-md' : 'border border-[#E17A17] text-[#E17A17] bg-transparent hover:bg-[#E17A17] hover:text-[#1D4BA6]'"
                        class="px-6 py-3 font-semibold rounded-lg transition">
                        Contact
                    </button>

                    <!-- Work With Us button -->
                    <button type="button" (click)="toggleForm('work')"
                        [ngClass]="showWorkWithUs ? 'bg-[#E17A17] text-[#1D4BA6] shadow-md' : 'border border-[#E17A17] text-[#E17A17] bg-transparent hover:bg-[#E17A17] hover:text-[#1D4BA6]'"
                        class="px-6 py-3 font-semibold rounded-lg transition">
                        Work With Us
                    </button>
                </div>


            </div>
            <!--  CONTACT FORM  -->
            <div *ngIf="!showWorkWithUs" class="bg-white rounded-2xl shadow-xl p-8 text-gray-800 mt-3 md:mt-6">
                <h3 class="text-2xl font-bold text-[#1D4BA6] mb-6">Contact Us</h3>

                <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="space-y-5">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                        <!-- Full Name -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Full Name</label>
                            <input formControlName="name" type="text" placeholder="Enter your full name"
                                class="w-full border rounded-lg px-4 py-3 " />
                            <p *ngIf="submitted && fContact['name'].errors" class="text-red-500 text-sm mt-1">
                                <span *ngIf="fContact['name'].errors['required']">Name is required.</span>
                                <span *ngIf="fContact['name'].errors['minlength']">Name must be at least 2
                                    characters.</span>
                            </p>
                        </div>

                        <!-- Organization -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Organization</label>
                            <input formControlName="company" type="text" placeholder="Enter your organization"
                                class="w-full border rounded-lg px-4 py-3 " />
                        </div>

                        <!-- Email -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Email Address</label>
                            <input formControlName="email" type="email" placeholder="Enter your email"
                                class="w-full border rounded-lg px-4 py-3 " />
                            <p *ngIf="submitted && fContact['email'].errors" class="text-red-500 text-sm mt-1">
                                <span *ngIf="fContact['email'].errors['required']">Email is required.</span>
                                <span *ngIf="fContact['email'].errors['email']">Enter a valid email.</span>
                            </p>
                        </div>

                        <!-- Phone -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Phone</label>
                            <input formControlName="phone" type="text" placeholder="Optional"
                                class="w-full border rounded-lg px-4 py-3 " />
                        </div>

                        <!-- Country -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Country / Region</label>
                            <input formControlName="country" type="text" placeholder="Enter country"
                                class="w-full border rounded-lg px-4 py-3 " />
                        </div>

                        <!-- Subject -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Subject</label>
                            <input formControlName="subject" type="text" placeholder="Short subject"
                                class="w-full border rounded-lg px-4 py-3 " />
                        </div>
                    </div>

                    <!-- Message -->
                    <div>
                        <label class="block text-sm font-medium mb-1">Message</label>
                        <textarea formControlName="message" rows="3" placeholder="Enter your message"
                            class="w-full border rounded-lg px-4 py-3 "></textarea>
                        <p *ngIf="submitted && fContact['message'].errors" class="text-red-500 text-sm mt-1">
                            <span *ngIf="fContact['message'].errors['required']">Message is required.</span>
                            <span *ngIf="fContact['message'].errors['minlength']">At least 10 characters
                                required.</span>
                            <span *ngIf="fContact['message'].errors['maxlength']">Max 300 characters allowed.</span>
                        </p>
                    </div>

                    <button type="submit"
                        class="w-full bg-[#1D4BA6] text-white font-semibold py-3 rounded-lg shadow-md hover:bg-[#E17A17] hover:text-[#1D4BA6] transition">
                        Send Message
                    </button>
                </form>
            </div>

            <!--  WORK WITH US FORM  -->
            <div *ngIf="showWorkWithUs" class="bg-white rounded-2xl shadow-xl p-8 text-gray-800 mt-6">
                <h3 class="text-2xl font-bold text-[#1D4BA6] mb-6">Work With Us</h3>

                <form [formGroup]="workForm" (ngSubmit)="onSubmit()" class="space-y-5">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                        <!-- Full Name -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Full Name</label>
                            <input formControlName="fullName" type="text" placeholder="Enter your full name"
                                class="w-full border rounded-lg px-4 py-3 " />
                            <p *ngIf="submitted && fWork['fullName'].errors" class="text-red-500 text-sm mt-1">
                                Full Name is required.
                            </p>
                        </div>

                        <!-- Organization -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Organization / Startup</label>
                            <input formControlName="organization" type="text" placeholder="Enter organization"
                                class="w-full border rounded-lg px-4 py-3 " />
                            <p *ngIf="submitted && fWork['organization'].errors" class="text-red-500 text-sm mt-1">
                                Organization is required.
                            </p>
                        </div>

                        <!-- Email -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Email Address</label>
                            <input formControlName="email" type="email" placeholder="Enter email"
                                class="w-full border rounded-lg px-4 py-3 " />
                            <p *ngIf="submitted && fWork['email'].errors" class="text-red-500 text-sm mt-1">
                                <span *ngIf="fWork['email'].errors['required']">Email is required.</span>
                                <span *ngIf="fWork['email'].errors['email']">Enter a valid email.</span>
                            </p>
                        </div>

                        <!-- Phone -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Phone / WhatsApp</label>
                            <input formControlName="phone" type="text" placeholder="+91 98765 43210"
                                class="w-full border rounded-lg px-4 py-3 " />
                        </div>

                        <!-- Country -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Country / Region</label>
                            <input formControlName="country" type="text" placeholder="Enter country"
                                class="w-full border rounded-lg px-4 py-3 " />
                        </div>

                        <!-- Website -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Website / LinkedIn</label>
                            <input formControlName="website" type="url" placeholder="https://example.com"
                                class="w-full border rounded-lg px-4 py-3 " />
                        </div>

                        <!-- Sector -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Technology Sector</label>
                            <select formControlName="sector"
                                class="w-full border rounded-lg px-4 py-3 ">
                                <option value="">Select sector</option>
                                <option>Defence</option>
                                <option>SpaceTech</option>
                                <option>Clean Energy</option>
                                <option>Quantum</option>
                                <option>MedTech</option>
                            </select>
                        </div>

                        <!-- Stage -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Stage of Development</label>
                            <select formControlName="stage"
                                class="w-full border rounded-lg px-4 py-3 ">
                                <option value="">Select stage</option>
                                <option>Prototype</option>
                                <option>Pilot</option>
                                <option>Commercial</option>
                                <option>Scaling</option>
                            </select>
                        </div>
                    </div>

                    <!-- Description -->
                    <div>
                        <label class="block text-sm font-medium mb-1">Brief Description</label>
                        <textarea formControlName="description" rows="3" placeholder="Describe your technology/product"
                            class="w-full border rounded-lg px-4 py-3 "></textarea>
                    </div>

                    <!-- Partnership Interests -->
                    <div class="space-y-2">
                        <p class="text-sm font-medium">Partnership Interests</p>
                        <div class="flex flex-wrap gap-4">
                            <label><input type="checkbox" formControlName="distribution" /> Distribution</label>
                            <label><input type="checkbox" formControlName="investment" /> Investment</label>
                            <label><input type="checkbox" formControlName="govtAccess" /> Government Access</label>
                            <label><input type="checkbox" formControlName="jointDev" /> Joint Development</label>
                        </div>
                    </div>

                    <!-- Upload -->
                    <div>
                        <label class="block text-sm font-medium mb-1">Upload Pitch Deck / Brochure</label>
                        <input type="file" formControlName="file" class="w-full border rounded-lg px-4 py-3" />
                    </div>

                    <button type="submit"
                        class="w-full bg-[#1D4BA6] text-white font-semibold py-3 rounded-lg shadow-md hover:bg-[#E17A17] hover:text-[#1D4BA6] transition">
                        Submit Proposal
                    </button>
                </form>
            </div>

        </div>
    </section>




</main>

<!-- Go To Top Button -->
<button
  *ngIf="showGoToTop"
  (click)="scrollToTop()"
  class="fixed bottom-6 right-6 bg-[#E17A17] text-white px-3 py-2 rounded-full shadow-lg 
         hover:bg-[#1D4BA6] transition z-50 text-2xl"
  aria-label="Go to top">
  ⬆
</button>
